const RobotMonitorTypeEnum = {
    0: "İş Kazası",
    1: "EVizite",
    2: "Tahakkuk",
    3: "EBorc",
};

export default RobotMonitorTypeEnum;